"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBAlertNotification;
var _react = _interopRequireDefault(require("react"));
var _SVBTypography = require("../../SVBTypography");
var _chevron_left = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/chevron_left.svg"));
var _Close = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/Close.svg"));
var _Bell = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/Bell.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * SVBAlertNotification
 * @param title: define title
 * @param actions: add one or two actions in the header
 * @param notifications: to show the notifications list
 * @param backClick: to trigger a function on back button
 * @param mainCloseClick: to show the notifications list
 * @param notificationCloseClick: to trigger a function on notification close button
 * @returns right side bar element with notifications
 */
function SVBAlertNotification(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "alertNotifications__container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "alertNotifications__title"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "alertNotifications__title-icon",
    alt: "chevronLeft",
    src: _chevron_left.default,
    onClick: props === null || props === void 0 ? void 0 : props.backClick
  }), /*#__PURE__*/_react.default.createElement(_SVBTypography.SVBTypography, {
    type: "sub-heading"
  }, props !== null && props !== void 0 && props.title ? props === null || props === void 0 ? void 0 : props.title : ''), /*#__PURE__*/_react.default.createElement("img", {
    className: "alertNotifications__title-icon",
    alt: "close",
    src: _Close.default,
    onClick: props === null || props === void 0 ? void 0 : props.mainCloseClick
  })), props.actions && (props === null || props === void 0 ? void 0 : props.notifications) && /*#__PURE__*/_react.default.createElement("div", {
    className: "alertNotifications__actions"
  }, props === null || props === void 0 ? void 0 : props.actions[0], props === null || props === void 0 ? void 0 : props.actions[1]), (props === null || props === void 0 ? void 0 : props.notifications) && (props === null || props === void 0 ? void 0 : props.notifications.map(notification => /*#__PURE__*/_react.default.createElement("div", {
    className: "alertNotifications__notification",
    key: notification.key
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "alertNotifications__notification-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "alertNotifications__notification-column ".concat(notification !== null && notification !== void 0 && notification.unread ? 'unread' : '')
  }, /*#__PURE__*/_react.default.createElement(_SVBTypography.SVBTypography, {
    className: "alertNotifications__notification-text",
    type: "paragraph"
  }, notification === null || notification === void 0 ? void 0 : notification.text), /*#__PURE__*/_react.default.createElement(_SVBTypography.SVBTypography, {
    className: "alertNotifications__notification-date",
    type: "paragraph",
    variant: "small"
  }, notification === null || notification === void 0 ? void 0 : notification.dateString)), /*#__PURE__*/_react.default.createElement("div", {
    className: "alertNotifications__notification-column"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "alertNotifications__notification-icon",
    alt: "close",
    src: _Close.default,
    onClick: props.notificationCloseClick
  })))))), (!(props !== null && props !== void 0 && props.notifications) || (props === null || props === void 0 ? void 0 : props.notifications.length) === 0) && /*#__PURE__*/_react.default.createElement("div", {
    className: "alertNotifications__anyNotification"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "alertNotifications__anyNotification-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "alertNotifications__anyNotification-iconContainer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "alertNotifications__anyNotification-icon",
    alt: "bell",
    src: _Bell.default
  })), /*#__PURE__*/_react.default.createElement(_SVBTypography.SVBTypography, {
    className: "alertNotifications__anyNotification-title",
    type: "sub-heading"
  }, "No notifications"), /*#__PURE__*/_react.default.createElement("div", {
    className: "alertNotifications__anyNotification-text"
  }, /*#__PURE__*/_react.default.createElement(_SVBTypography.SVBTypography, {
    type: "paragraph",
    variant: "small"
  }, "When you have notifications, you'll see them here.")))));
}